import { Component, OnInit } from '@angular/core';
import { CookieManagement } from '../app.component';
import { SEOService } from '../services/seo.service';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})

export class CookieComponent implements OnInit {

  pageTitle = "Leone Lifestyle | Cookie Policy";
  desc = "Alimentarsi oggi"
  shareImg = "share.jpg";

  constructor(private seo: SEOService) {}
  
  ngOnInit(): void {
    this.seo.updatePageTags(this.pageTitle, this.desc, this.shareImg);

    var CookieInit = new CookieManagement()
    CookieInit.CookieLangHider()
  }
}
